import {css, view, rawCss} from '@sail/ui/deprecated';
import {ChatBubble} from './ChatBubble';
import {ChatRow} from './ChatRow';

type Props = {
  position?: 'start' | 'end';
  avatar?: React.ReactNode | null | undefined;
  background?: 'neutral100' | 'neutral600';
};

const loadingRowStyles = css({
  animationName: css.value('loading'),
  animationDuration: css.value('1.5s'),
  animationIterationCount: css.value('infinite'),
});

const loadingAnimation = rawCss`
    @keyframes loading {
      0% {
        fill: #d7dfea;
      }

      50% {
        fill: #6b7c93;
      }

      75% {
        fill: #d7dfea;
      }

      100% {
        fill: #d7dfea;
      }
    }
`;

export const TypingRow = ({
  position,
  avatar,
  background = 'neutral100',
}: Props) => {
  return (
    <view.div data-testid="typing-row">
      <ChatRow avatar={avatar} position={position}>
        <ChatBubble background={background}>
          <view.span
            uses={[loadingAnimation]}
            css={{
              // constraining the dimensions to 32px
              // the viewbox within the svg will ensure the
              // dimensions are accurate within that constraint (32x8)
              maxWidth: css.value('32px'),
              // the 100% height will ensure this span container
              // fills the default height of the ChatBubble,
              // allowing us to center the svc vertically
              height: css.value('100%'),
              // center the svg within the span
              stack: 'y',
              align: 'center',
            }}
          >
            <svg
              // scale the svg to fill the span container
              width="100%"
              height="100%"
              // constrain the svg to 32x8 relative to the scaled dimensions
              viewBox="0 0 32 8"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
            >
              <view.circle
                data-testid="typing-row-circle"
                uses={[loadingRowStyles]}
                cx={4}
                cy={4}
                r={4}
                css={{
                  animationDelay: css.value('-750ms'),
                }}
              />
              <view.circle
                data-testid="typing-row-circle"
                uses={[loadingRowStyles]}
                cx={16}
                cy={4}
                r={4}
                css={{
                  animationDelay: css.value('-500ms'),
                }}
              />
              <view.circle
                data-testid="typing-row-circle"
                uses={[loadingRowStyles]}
                cx={28}
                cy={4}
                r={4}
                css={{
                  animationDelay: css.value('-250ms'),
                }}
              />
            </svg>
          </view.span>
        </ChatBubble>
      </ChatRow>
    </view.div>
  );
};
